import { transformDTODate } from "@skylab-shared/core";
import { Transform } from "class-transformer";
import { FormOfSettlementWithTaxOffice } from "./form-of-settlement-with-tax-office";
import { PersonKind } from "./person-kind";
import { RoleRelativeToOtherSeller } from "./role-relative-to-other-seller";
import { TaxReturnFrequency } from "./tax-return-frequency";
import { VatReleaseReasonSource } from "./vat-release-reason-source";
import { ZusContribution } from "./zus-contribution";

export class CompanyParametersDTO {
	public version: string;
    public accountingOnlineReceiver: {
		channelId: string;
        id: string;
        password: string;
        name: string;
	} | null;
    public advanceIncomeTaxPaymentFrequency: TaxReturnFrequency;
    public cashBasis: boolean;
    public formOfSettlement: FormOfSettlementWithTaxOffice;
    public logo: string;
    public otherSeller: {
		address: string;
        city: string;
        countryId: number;
        issueDocumentsToOtherSeller: boolean;
        name: string;
        nip: string;
        zipCode: string;
        roleRelativeToOtherSeller: RoleRelativeToOtherSeller;
	} | null;
    public personKind: PersonKind | null;
    public taxOfficeCode: string | null;
    @Transform(transformDTODate, { toClassOnly: true }) public taxpayerDateOfBirth?: Date;
    public taxpayerFirstName?: string;
    public taxpayerSurname?: string;
    public ueVatPayer: boolean;
    public vatPayer: boolean;
    public ossRegistered: boolean;
    public vatReleaseReasonCustomName: string | null;
    public vatReleaseReasonId?: number | null;
    public vatReleaseReasonSource?: VatReleaseReasonSource | null;
    public vatReturnFrequency: TaxReturnFrequency;
    public zusContribution: ZusContribution;
    public bdoNumber: string;
    public printBdoNumber: boolean;
    public eoriNumber: string;
    public printEoriNumber: boolean;
    public krsNumber: string;
    public printKrsNumber: boolean;
    public contactEmail: string | null;
    public contactPhoneNumber: string | null;
}
